import { useMutation, useQueryClient } from '@tanstack/react-query';

import { queryKeysSupplier } from '../queryKeys';

import { resendActivation } from './resendActivation';
import { type ResendActivationMutationOptions } from './types';

/**
 * React Query based custom hook for resending a supplier activation request.
 *
 * Invalidates the activation request queries on success.
 *
 * @param options - Optional mutation options.
 * @returns The mutation result.
 *
 * @see https://app.dev.vestigas.com/redoc#tag/Suppliers/operation/post_resend_activation_suppliers_actions__req_id__resend_post
 */
export const useMutationResendActivation = (
  options?: ResendActivationMutationOptions,
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ reqId, payload }) =>
      resendActivation(reqId, payload ?? undefined),
    onSettled() {
      void queryClient.invalidateQueries({
        queryKey: queryKeysSupplier.getActivationRequest(undefined),
      });
      void queryClient.invalidateQueries({
        queryKey: queryKeysSupplier.getActivationRequests(undefined),
      });
    },
    throwOnError: false,
    ...options,
  });
};
